import { reactive } from "vue";
import {
  IdomBotItem,
  IdomChannelItem,
  IdomMessagingPolicy,
  IdomSettings,
  IdomEntityItem,
  IdomPlatform,
  IdomAutosendOption,
  IdomRole,
} from "../../models";

export interface IdomStateInterface {
  bots: IdomBotItem[];
  settings: IdomSettings;
  channels: IdomChannelItem[];
  policies: IdomMessagingPolicy[];
  entities: IdomEntityItem[];
  platforms: IdomPlatform[];
  autosendOptions: IdomAutosendOption[];
  roles: IdomRole[];
  botsCount: number;
  entitiesCount: number;
  channelsCount: number;
  userTags: string[];
}

function state(): IdomStateInterface {
  return {
    entitiesCount: 0,
    channelsCount: 0,
    botsCount: 0,
    bots: reactive([]),
    settings: reactive({
      ref: "",
      message_delay: 0,
      value: "",
      name: "",
      policy: {
        name: "",
        ref: "",
        use_timer: false,
        value: "",
        label: "",
      },
      policyValue: "",
      premoderate_sending_enabled: false,
    }),
    channels: reactive([]),
    policies: reactive([]),
    entities: reactive([]),
    platforms: reactive([]),
    autosendOptions: reactive([]),
    roles: reactive([]),
    userTags: reactive([]),
  };
}

export default state;
